import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding hasHeader bgWhite" }
const _hoisted_2 = { class: "header withShadow d-flex aling-items-center justify-content-between py-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "fs_12 greyBlue" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "sideContainer" }, null, -1)

export function render(_ctx: any,_cache: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_post = _resolveComponent("post")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "sideContainer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_3
      ]),
      _createVNode("span", _hoisted_4, "#" + _toDisplayString(_ctx.topic.tag), 1),
      _hoisted_5
    ]),
    (_ctx.posts.length == 0)
      ? (_openBlock(), _createBlock(_component_localized_text, {
          key: 0,
          localizedKey: "app_ancoranessunpostperquestotopic",
          text: "Ancora nessun post per questo topic",
          class: "fs_14 greyBlue d-block ln_12 text-center"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.posts, (item, i) => {
      return (_openBlock(), _createBlock(_component_post, {
        class: "mb-3",
        key: item.identifier,
        ref: item.identifier,
        post: item,
        "community-identifier": _ctx.$store.state.community.identifier,
        onRemoved: ($event: any) => (_ctx.onRemoved($event, i)),
        "can-content": _ctx.$store.state.community.canContent
      }, null, 8, ["post", "community-identifier", "onRemoved", "can-content"]))
    }), 128))
  ]))
}